export default __webpack_public_path__ + "73fab9e129751c3abd89c627dd133633.png";